import React, { useState } from "react";
import toast from "react-hot-toast";
import styles from "./Contact.module.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    category: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/public/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || "Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", subject: "", category: "", message: "" });
      } else {
        toast.error(data.message || "Failed to send message.");
      }
    } catch (error) {
      toast.error("Failed to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.contactPage}>
      {/* Background Leaves */}
      <svg
        className={styles.bgLeafLeft}
        viewBox="0 0 200 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 50C50 50 100 100 100 200C100 300 50 350 0 350"
          stroke="#E0E8E2"
          strokeWidth="2"
        />
        <path
          d="M0 100C40 100 80 140 80 200C80 260 40 300 0 300"
          stroke="#E0E8E2"
          strokeWidth="2"
        />
        <path
          d="M0 150C30 150 60 170 60 200C60 230 30 250 0 250"
          stroke="#E0E8E2"
          strokeWidth="2"
        />
        <path
          d="M40 100C70 70 120 70 150 100C150 100 120 120 100 200"
          stroke="#E0E8E2"
          strokeWidth="2"
        />
      </svg>

      <div className={styles.contentWrapper}>
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h1 className={styles.pageTitle}>Contact Us</h1>
          <div className={styles.floralDivider}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
              <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"></path>
              <path d="M12 12m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0"></path>
            </svg>
          </div>
          <p className={styles.leadText}>We're here to help you.</p>
        </div>

        <div className={styles.contactLayout}>
          {/* Top Row: Contact Info Cards */}
          <div className={styles.infoGrid}>
            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Get In Touch</h3>
              <ul className={styles.infoList}>
                <li className={styles.infoItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                  <div className={styles.infoText}>+91 99209 09082</div>
                </li>
                <li className={styles.infoItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <div className={styles.infoText}>
                    sanskrutishubhaangan@gmail.com
                  </div>
                </li>
                <li className={styles.infoItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <div className={styles.infoText}>
                    193, Sanskriti Shubh Aangan,
                    <br />
                    Talawali Chanda, Manglia,
                    <br />
                    Indore – 453771, Madhya Pradesh
                  </div>
                </li>
                <li className={styles.infoItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </div>
                  <div className={styles.infoText}>
                    Mon - Sat : 9:00 AM - 6:00 PM
                  </div>
                </li>
              </ul>
            </div>

            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Emergency Contacts</h3>
              <div className={styles.emergencyList}>
                <div className={styles.emergencyItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                      <polyline points="9 12 11 14 15 10"></polyline>
                    </svg>
                  </div>
                  <div className={styles.emergencyText}>
                    <span className={styles.emergencyLabel}>
                      Security Office
                    </span>
                    <span className={styles.emergencyNumber}>
                      +91 00000 00000
                    </span>
                  </div>
                </div>
                <div className={styles.emergencyItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div className={styles.emergencyText}>
                    <span className={styles.emergencyLabel}>
                      Society Secretary
                    </span>
                    <span className={styles.emergencyNumber}>
                        +91 99209 09082
                    </span>
                  </div>
                </div>
                <div className={styles.emergencyItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="1" y="3" width="15" height="13"></rect>
                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                      <circle cx="5.5" cy="18.5" r="2.5"></circle>
                      <circle cx="18.5" cy="18.5" r="2.5"></circle>
                      <line x1="8" y1="9" x2="8" y2="9"></line>
                    </svg>
                  </div>
                  <div className={styles.emergencyText}>
                    <span className={styles.emergencyLabel}>Ambulance</span>
                    <span className={styles.emergencyNumber}>108</span>
                  </div>
                </div>
                <div className={styles.emergencyItem}>
                  <div className={styles.iconBadge}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18"></path>
                      <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                      <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                      <path d="M10 6h4"></path>
                      <path d="M10 10h4"></path>
                      <path d="M10 14h4"></path>
                      <path d="M10 18h4"></path>
                    </svg>
                  </div>
                  <div className={styles.emergencyText}>
                    <span className={styles.emergencyLabel}>Fire Brigade</span>
                    <span className={styles.emergencyNumber}>101</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Middle Row: Contact Form */}
          <div className={styles.formContainer}>
            <div className={`${styles.card} ${styles.cardWhite}`}>
              <h3 className={styles.cardTitle}>Send Us a Message</h3>
              <form className={styles.contactForm} onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                  <label>Your Name</label>
                  <div className={styles.inputWrapper}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      className={styles.inputField}
                      required
                    />
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label>Email Address</label>
                  <div className={styles.inputWrapper}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className={styles.inputField}
                      required
                    />
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label>Mobile Number</label>
                  <div className={styles.inputWrapper}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter mobile number"
                      className={styles.inputField}
                      required
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label>Subject</label>
                    <div className={styles.inputWrapper}>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                      <input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="Enter subject"
                        className={styles.inputField}
                        required
                      />
                    </div>
                  </div>
                  <div className={styles.formGroup}>
                    <label>Select Category</label>
                    <div className={styles.inputWrapper}>
                      <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        className={`${styles.inputField} ${styles.selectField}`}
                        required
                      >
                        <option value="">Select a category</option>
                        <option value="Maintenance">Maintenance Request</option>
                        <option value="Billing">Billing & Payments</option>
                        <option value="Security">Security Concern</option>
                        <option value="Feedback">Suggestion / Feedback</option>
                        <option value="General">General Inquiry</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label>Your Message</label>
                  <div
                    className={`${styles.inputWrapper} ${styles.textareaWrapper}`}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Type your message here..."
                      className={`${styles.inputField} ${styles.textareaField}`}
                      required
                    ></textarea>
                  </div>
                </div>

                <button className={styles.submitBtn} disabled={loading}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className={styles.bottomGrid}>
          <div className={styles.mapCard}>
            <iframe
              src="https://maps.google.com/maps?q=Sanskriti+shubhangan+colony,+Satellite+Junction,+AB+Rd,+Manoj+Nayar+Nagar,+Dewas+Naka,+SR+Compound,+Indore,+Madhya+Pradesh+453771&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="250"
              style={{ border: 0, borderRadius: "12px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Society Map Location"
            ></iframe>
          </div>

          <div className={`${styles.card} ${styles.reachCard}`}>
            <h3 className={styles.cardTitle}>We're Easy to Reach</h3>
            <p className={styles.reachText}>
              Located in the heart of Indore, Sanskriti Shubh Aangan is well
              connected and easy to find.
            </p>

            <div className={styles.reachGrid}>
              <div className={styles.reachItem}>
                <div className={styles.reachIcon}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div>
                  <h4>Prime Location</h4>
                  <p>Central & accessible</p>
                </div>
              </div>
              <div className={styles.reachItem}>
                <div className={styles.reachIcon}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="8"
                      width="18"
                      height="10"
                      rx="2"
                      ry="2"
                    ></rect>
                    <path d="M12 4v4"></path>
                    <path d="M10 4h4"></path>
                    <path d="M7 22v-4"></path>
                    <path d="M17 22v-4"></path>
                    <path d="M8 13h.01"></path>
                    <path d="M16 13h.01"></path>
                  </svg>
                </div>
                <div>
                  <h4>Ample Parking</h4>
                  <p>Visitor parking available</p>
                </div>
              </div>
              <div className={styles.reachItem}>
                <div className={styles.reachIcon}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 14h16"></path>
                    <path d="M4 19h16"></path>
                    <path d="M4 9h16"></path>
                    <path d="M9 4l-5 5 5 5"></path>
                    <path d="M15 20l5-5-5-5"></path>
                  </svg>
                </div>
                <div>
                  <h4>Public Transport</h4>
                  <p>Bus stop nearby</p>
                </div>
              </div>
              <div className={styles.reachItem}>
                <div className={styles.reachIcon}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    <path d="M9 12l2 2 4-4"></path>
                  </svg>
                </div>
                <div>
                  <h4>Safe & Secure</h4>
                  <p>24x7 Security</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.feedbackBanner}>
          <div className={styles.feedbackContent}>
            <div className={styles.feedbackIcon}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div>
              <h3 className={styles.cardTitle}>We Value Your Feedback</h3>
              <p className={styles.reachText}>
                Your suggestions help us improve our community and serve you
                better every day.
              </p>
            </div>
          </div>
          <button className={styles.outlineBtn}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            Share Your Suggestions
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
